module.exports = "a {\n    cursor: pointer;\n    color: #38B6A0 !important;\n}\n\np {\n    /* padding: 20px 0; */\n    margin-top: 26px;\n    \n}\n\n.pagination>li.active>a {\n  background: #38B6A0;\n  border: 1px solid #38B6A0;\n  color: #fff !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/pagination/pagination.component.css
// module id = ./src/app/shared/components/pagination/pagination.component.css
// module chunks = main